import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
 message: {
  display: 'flex',
  alignItems: 'stretch',
  position: 'relative',
  flex: '0',
  fontWeight: 500,
  fontSize: '24px',
  lineHeight: '24px',
  color: '#8f8f90',
  margin: '80px',
 },
});

const NotAvailable = () => {
 const classes = useStyles();

 const messageData = localStorage.getItem('isAisAvailableMessage');
 const message = messageData ? messageData : '';

 return <div className={classes.message}>{message}</div>;
};

export default NotAvailable;
